module.exports = __webpack_public_path__ + "img/button_Close.d7fa3dbc.svg";